import { Priority, Progress, Months, Stage } from '../enums';
export const getAllPriorities = () => {
    return [
        { id: Priority.LOW, name: 'Low', status: 'low', color: 'low-priority', icon: 'pi-sort-amount-down', severity: 'warning' },
        { id: Priority.MEDIUM, name: 'Medium', status: 'medium', color: 'medium-priority', icon: 'pi-sort-alt', severity: 'success' },
        { id: Priority.HIGH, name: 'High', status: 'high', color: 'high-priority', icon: 'pi-sort-amount-up', severity: 'danger' },
    ];
};

export const getAllProgress = () => {
    return [
        { id: Progress.NO_PROGRESS, name: 'No Progress', color: 'no-progress', icon: 'pi-times', status: 'noprogress', severity: 'warning' },
        { id: Progress.IN_PROGRESS, name: 'In Progress', color: 'in-progress', icon: 'pi-spinner', status: 'inprogress', severity: 'success' },
        { id: Progress.COMPLETED, name: 'Completed', color: 'completed-progress', icon: 'pi-check', status: 'completed', severity: 'danger' },
        { id: Progress.ARCHIVE, name: 'QA/Archive', color: 'qa-archive', icon: 'pi-folder-plus', status: 'qaarchive', severity: 'info' },
    ];
};

export const getArchiveStatus = () => {
    return [
        { id: 'archive', name: 'Archived', color: 'no-progress', icon: 'pi-times', status: 'noprogress', severity: 'warning' },
    ];
};

export const getAllMonths = () => {
    return [
        { name: 'January', id: Months.JANUARY },
        { name: 'February', id: Months.FEBRUARY },
        { name: 'March', id: Months.MARCH },
        { name: 'April', id: Months.APRIL },
        { name: 'May', id: Months.MAY },
        { name: 'June', id: Months.JUNE },
        { name: 'July', id: Months.JULY },
        { name: 'August', id: Months.AUGUST },
        { name: 'September', id: Months.SEPTEMBER },
        { name: 'October', id: Months.OCTOBER },
        { name: 'November', id: Months.NOVEMBER },
        { name: 'December', id: Months.DECEMBER },
    ];
};


export const getAllStages = () => {
    return [
        { name: 'Not Started', id: Stage.NOT_STARTED },
        { name: 'Started', id: Stage.STARTED },
        { name: 'Uncompleted', id: Stage.UNCOMPLETED },
        { name: 'Completed', id: Stage.COMPLETED },
        // { name: 'Paused', id: Stage.PAUSED },
        // { name: 'Review', id: Stage.REVIEW }
    ];
};


export const getStageBadgeClass = (stage) => {
    switch (stage) {
        case Stage.NOT_STARTED:
            return 'status-badge status-noprogress'; // No Progress
        case Stage.STARTED:
            return 'status-badge status-inprogress'; // In Progress
        case Stage.UNCOMPLETED:
            return 'status-badge status-low'; // Low Priority / Uncompleted
        case Stage.COMPLETED:
            return 'status-badge status-completed'; // Completed
        default:
            return 'status-badge status-noprogress'; // Default fallback
    }
};

export const getStageName = (stage) => {
    const stageObj = getAllStages().find(s => s.id === stage);
    return stageObj ? stageObj.name : 'Unknown';
};


export const ChecklistPeriod = () => {
    return [
        { name: 'Daily', id: 1 },
        { name: 'Weekly', id: 7 },
        { name: 'Monthly', id: 30 },
        { name: 'Quarterly', id: 90 },
        { name: 'Yearly', id: 365 },
    ];
};

export const getAllAssuranceLevels = () => {
    return [
        {
            id: 'inadequate',
            name: 'Inadequate',
            percentage: '0–19%',
            color: 'red',
            label: 'Inadequate (0–19%)',
            severity: 'danger',
        },
        {
            id: 'requires_improvement',
            name: 'Requires Improvement',
            percentage: '20–49%',
            color: 'darkred',
            label: 'Requires Improvement (20–49%)',
            severity: 'warning',
        },
        {
            id: 'adequate',
            name: 'Adequate',
            percentage: '50–69%',
            color: 'orange',
            label: 'Adequate (50–69%)',
            severity: 'info',
        },
        {
            id: 'good',
            name: 'Good',
            percentage: '70–89%',
            color: 'lightgreen',
            label: 'Good (70–89%)',
            severity: 'success',
        },
        {
            id: 'outstanding',
            name: 'Outstanding',
            percentage: '90–100%',
            color: 'darkgreen',
            label: 'Outstanding (90–100%)',
            severity: 'success',
        }
    ];
};

export const getAssuranceLabel = (id) => {
    const match = getAllAssuranceLevels().find(level => level.id === id);
    return match ? match.percentage : '—';
};

export const categories = [
    {
        value: 1,
        label: 'Incident',
    },
    {
        value: 2,
        label: 'Exercise',
    },
    {
        value: 3,
        label: 'Training',
    },
    {
        value: 4,
        label: "Non Operational"
    }
];

export const getCategoriesForIncidentList = () => {
    return categories.map(cat => ({
        code: cat.value,
        description: cat.label
    }));
};

export const getCategoriesForDebrief = () => {
    return categories.map(cat => ({
        id: cat.value,
        name: cat.label
    }));
};



